// An access point's LED setting on its page in Operate (ADR-0332): read and
// shown, never changed here. Operate reads the network and Design changes it
// (ADR-0149 decision 1), so the change is offered as the way to Design ›
// Physical › Equipment, where `ApLedsPanel` writes it.
import { api } from "../../api/client";
import { useQuery } from "../../api/hooks";
import ChangeInDesign from "../../shell/ChangeInDesign";
import { apLedsWords } from "./apLedsWords";

// The way to change it is the page head's *Change this in Design*, which lands
// on the same device in Equipment (#1801); it is drawn here only for a caller
// the head offers none to, so the page says it once.
export default function ApLedsFact({ serial, mayConfigure, headOffers = false }: {
  serial: string; mayConfigure: boolean;
  /** The page's head already offers *Change this in Design* for this device. */
  headOffers?: boolean;
}) {
  const q = useQuery(() => api.GET("/devices/{serial}/leds", { params: { path: { serial } } }), [serial]);
  if (q.status === "loading") return <span className="muted">…</span>;
  if (q.status === "error" || !q.data) return <span className="muted">—</span>;
  return (
    <>
      {apLedsWords(q.data)}
      {mayConfigure && !headOffers && <> <ChangeInDesign to="/design/physical/equipment" facets={{ serial }} /></>}
    </>
  );
}
